"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _constants = require("./constants");

var _BrandInfo = _interopRequireDefault(require("./BrandInfo"));

var _Button = _interopRequireDefault(require("./Button"));

var _Link = _interopRequireDefault(require("./Link"));

var _Menu = _interopRequireDefault(require("./Menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TopNavFrame = (0, _styledComponents.default)(_Flex.default).attrs({
  as: 'header'
}).withConfig({
  displayName: "TopNav__TopNavFrame",
  componentId: "d7ybm2-0"
})(["align-items:center;background-color:", ";color:", ";height:", ";justify-content:space-between;"], (0, _toColorString.default)(_constants.BG_COLOR), (0, _toColorString.default)(_constants.BG_COLOR.fg), (0, _rem.default)(_constants.TOP_NAV_HEIGHT));

function TopNav(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(TopNavFrame, rest, children);
}

TopNav.BrandInfo = _BrandInfo.default;
TopNav.Button = _Button.default;
TopNav.Link = _Link.default;
TopNav.Menu = _Menu.default;
var _default = TopNav;
exports.default = _default;